var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 611,
    height: 218,
    viewBox: "0 0 611 218",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9079_4896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.439 151.14C397.579 151.14 431.779 149.45 431.779 149.45L434.159 85.79C434.159 85.79 417.899 46.51 417.559 44.48C417.219 42.45 416.139 37.92 416.139 37.92L337.649 45.83L340.999 150.46L342.359 154.53C342.359 154.53 379.299 151.14 388.439 151.14Z",
    fill: "#F6AA62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.539 37.46C383.789 14.37 396.329 33.22 387.729 37.91C403.729 32.34 392.579 57.63 385.019 44.68C383.769 59.1 373.279 59.36 373.279 51.45C362.069 67.89 355.689 48.73 365.609 43.78C356.129 41.07 369.219 27.07 375.539 37.46Z",
    fill: "#EFE6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.44 151.14C397.58 151.14 431.78 149.45 431.78 149.45L434.34 85.85L372.39 94.28L339.21 96.69L341 150.46L342.36 154.53C342.36 154.53 379.3 151.14 388.44 151.14Z",
    fill: "#D0927C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.82 103.06L427.38 103.39L427.04 126.42L433.14 126.76",
    stroke: "#874E50",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.29 65.65L338.73 79.13C340.08 79.23 341.43 79.28 342.79 79.28C359.13 79.28 342.49 77.95 426.88 68.08C425.46 64.62 424.01 61.08 422.69 57.76C401.21 59.06 357.6 59.19 338.29 65.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.67 62.42C409.17 66.27 396.67 64.8 380.99 66.06C365.99 67.27 353.39 68.89 338.33 69.87",
    stroke: "#874E50",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.34 85.85L372.39 94.28L345.39 96.28L344.59 154.36C348.03 154.05 355.01 153.44 362.51 152.83L363.51 104.83L434.06 93L434.34 85.85Z",
    fill: "#524344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.26 105.09C227.26 105.09 223.2 134.89 222.74 141.66C222.28 148.43 220.94 161.07 221.39 165.59C221.84 170.11 222.29 201.71 222.29 201.71C222.29 201.71 267.44 201.71 274.21 201.26C280.98 200.81 351.87 198.1 351.87 198.1C351.87 198.1 354.58 152.95 354.13 148.88C353.68 144.81 353.68 97.88 353.68 97.88C353.68 97.88 267.1 102 262.14 102C257.18 102 227.26 105.09 227.26 105.09Z",
    fill: "#F6AA62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.68 155.15C221.347 158.619 221.251 162.107 221.39 165.59C221.84 170.1 222.29 201.71 222.29 201.71C222.29 201.71 267.44 201.71 274.21 201.26C280.98 200.81 351.87 198.1 351.87 198.1C351.87 198.1 354.37 156.49 354.17 149.57C348.72 150.73 337.45 152.95 331.1 152.95C322.69 153 235.32 154.25 221.68 155.15Z",
    fill: "#D0927C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.229 159.27C232.229 159.27 232.68 177.78 233.13 181.84C233.58 185.9 233.579 191.32 233.579 191.32L256.579 189.97L256.119 157.91L232.229 159.27Z",
    stroke: "#874E50",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.16 186.02V174.84L235.39 175.52L243.51 160.62L255.37 171.8L248.25 174.17L248.93 185L242.16 186.02Z",
    stroke: "#874E50",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.26 135.12C342.78 135.12 348.3 135.21 353.82 135.39C353.82 130.44 353.74 124.74 353.72 119.29C339.78 119.29 325.72 119.02 311.72 119.02C268.11 119.02 254.48 122.02 225.62 122.02H225C224.08 129.23 223.14 136.84 222.81 140.62C261 139.07 299.05 135.12 337.26 135.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.55 125.74C345.93 125.59 339.41 124.21 332.77 124.21C332.68 124.21 239.58 130.14 229.45 130.14C227.81 130.14 226.17 130.14 224.54 130.03",
    stroke: "#874E50",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.85 133.66L301.69 138.94L359.15 146.21L360.48 113.84L251.5 122.43L248.85 133.66Z",
    fill: "#524344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.09 87.41V133.33L357.54 127.93L358.52 90.11L249.09 87.41Z",
    fill: "#D0927C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.09 102.7L361.74 104.9L362.11 90.15L249.09 90.55V102.7Z",
    fill: "#874E50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.019 91.64L325.609 118.14L352.529 118.06L352.609 91.72L326.019 91.64Z",
    stroke: "#874E50",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.85 91.05L331.31 106.07L338.16 106.15L337.82 114.96L344.51 115.07L343.49 105.59L349.14 105.6L340.85 91.05Z",
    stroke: "#874E50",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.679 0L253.529 1.35L258.609 26.37L361.819 27.84L369.679 0Z",
    fill: "#D0927C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.52 25.36H258.23L247.39 79.2L367.58 80.69L362.52 25.36Z",
    fill: "#874E50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.68 60.8L321.31 81.05L342.69 82.17L352.06 58.92L315.68 60.8Z",
    fill: "#874E50",
    stroke: "#BC7C70",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.309 60.05C315.679 64.55 327.679 65.67 335.939 64.55C344.199 63.43 351.689 62.67 352.059 58.55C352.429 54.43 335.559 54.42 328.809 56.3C322.059 58.18 314.929 55.55 315.309 60.05Z",
    fill: "#874E50",
    stroke: "#BC7C70",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.49 62.06L352.06 48.23L315.68 50.11L319.14 62.57",
    fill: "#874E50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.49 62.06L352.06 48.23L315.68 50.11L319.14 62.57",
    stroke: "#BC7C70",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.309 49.36C315.679 53.86 327.679 54.99 335.939 53.86C344.199 52.73 351.689 51.98 352.059 47.86C352.429 43.74 335.559 43.73 328.809 45.61C322.059 47.49 314.929 44.86 315.309 49.36Z",
    fill: "#874E50",
    stroke: "#BC7C70",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.49 51.55L352.06 37.73L315.68 39.61L319.14 52.07",
    fill: "#874E50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.49 51.55L352.06 37.73L315.68 39.61L319.14 52.07",
    stroke: "#BC7C70",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.309 38.86C315.679 43.36 327.679 44.48 335.939 43.36C344.199 42.24 351.689 41.48 352.059 37.36C352.429 33.24 335.559 33.23 328.809 35.11C322.059 36.99 314.929 34.36 315.309 38.86Z",
    fill: "#874E50",
    stroke: "#BC7C70",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.59 65.58C267.59 65.58 269.98 80.23 276.94 81.52C283.9 82.81 290.87 82.38 294.35 78.52C297.83 74.66 302.18 64.33 302.18 64.33L267.59 65.58Z",
    fill: "#874E50",
    stroke: "#BC7C70",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.359 65.61C268.669 70.77 278.679 75.07 286.949 73.78C295.219 72.49 303.949 66.47 301.749 62.17C299.549 57.87 294.349 57.01 285.639 57.44C276.929 57.87 266.059 60.45 267.359 65.61Z",
    fill: "#874E50",
    stroke: "#BC7C70",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.12 69.24C298.992 65.7197 300.681 62.1049 302.18 58.41L267.59 59.67C268.099 62.787 269.045 65.8167 270.4 68.67",
    fill: "#874E50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.12 69.24C298.992 65.7197 300.681 62.1049 302.18 58.41L267.59 59.67C268.099 62.787 269.045 65.8167 270.4 68.67",
    stroke: "#BC7C70",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.459 59.58C268.759 63.44 278.769 66.65 287.039 65.69C295.309 64.73 304.039 60.22 301.839 57.01C299.639 53.8 294.439 53.15 285.739 53.47C277.039 53.79 266.149 55.72 267.459 59.58Z",
    fill: "#874E50",
    stroke: "#BC7C70",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.12 62.67C298.993 59.1537 300.682 55.5421 302.18 51.85L267.59 53.11C268.101 56.2267 269.047 59.2562 270.4 62.11",
    fill: "#874E50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.12 62.67C298.993 59.1537 300.682 55.5421 302.18 51.85L267.59 53.11C268.101 56.2267 269.047 59.2562 270.4 62.11",
    stroke: "#BC7C70",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.459 53C268.759 56.86 278.769 60.07 287.039 59.11C295.309 58.15 304.039 53.64 301.839 50.43C299.639 47.22 294.439 46.57 285.739 46.89C277.039 47.21 266.149 49.16 267.459 53Z",
    fill: "#874E50",
    stroke: "#BC7C70",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.12 56.11C298.992 52.5898 300.681 48.9749 302.18 45.28L267.59 46.55C268.101 49.6667 269.047 52.6963 270.4 55.55",
    fill: "#874E50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.12 56.11C298.992 52.5898 300.681 48.9749 302.18 45.28L267.59 46.55C268.101 49.6667 269.047 52.6963 270.4 55.55",
    stroke: "#BC7C70",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.459 46.45C268.759 50.31 278.769 53.53 287.039 52.56C295.309 51.59 304.039 47.1 301.839 43.88C299.639 40.66 294.439 40.03 285.739 40.35C277.039 40.67 266.149 42.6 267.459 46.45Z",
    fill: "#874E50",
    stroke: "#BC7C70",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245 77.9C239.74 91.42 255.25 91.12 254.86 78.04C261.14 87.51 270.91 69.96 260.63 64.79C262.9 46.4 244.63 46.69 243.47 54.93C232.77 48.32 222.7 58.38 240.86 67.8C233.09 73.2 241.76 80.47 245 77.9Z",
    fill: "#EFE6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.58 68.57C252.58 68.57 246.05 64.98 244.89 57.66",
    stroke: "#D0927C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.6 78.52H246.71L226.06 94.1L225.72 98.16L372 96.47L373.36 93.42L367.6 78.52Z",
    fill: "#D0927C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.36 93.42L343.56 93.76L226.03 94.43L225.72 98.16L372 96.47L373.36 93.42Z",
    fill: "#F6AA62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8498 194.93C23.0898 171.85 35.6298 190.7 27.0398 195.39C43.0398 189.82 31.8798 215.11 24.3298 202.16C23.0698 216.58 12.5898 216.84 12.5898 208.93C1.37978 225.37 -5.00022 206.21 4.90978 201.26C-4.57022 198.55 8.52978 184.55 14.8498 194.93Z",
    fill: "#EFE6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.45 144.37C172.45 143.92 180.09 157.46 183.25 157.01C186.41 156.56 196.35 146.63 200.41 146.17C204.47 145.71 209.89 154.75 209.89 154.75C209.89 154.75 196.8 175.07 194.09 175.52C191.38 175.97 183.7 167.39 180.54 169.2C177.38 171.01 174.22 178.68 170.16 178.2C166.1 177.72 154.81 164.66 154.81 164.66C154.81 164.66 162.48 144.82 167.45 144.37Z",
    fill: "#EFE6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.51 156.11L178.51 165.86",
    stroke: "#D0927C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.35 176.4C434.44 179.56 437.61 190.85 443.47 193.11C449.33 195.37 451.6 205.3 458.37 205.3C465.14 205.3 474.18 197.62 478.69 198.98C483.2 200.34 486.82 204.85 492.24 203.98C497.66 203.11 496.75 195.4 502.17 190.89C507.59 186.38 515.71 178.7 515.71 178.7C515.71 178.7 507.13 168.77 503.52 168.31C499.91 167.85 498.1 155.67 498.1 155.67C498.1 155.67 486.82 170.53 485 176.4C483.18 182.27 478.68 180.01 473.71 178.66C468.74 177.31 461.07 185.43 461.07 185.43C461.07 185.43 453.85 169.63 448.43 169.18C443.01 168.73 443.43 172.79 440.76 174.6C438.09 176.41 436.25 173.24 435.35 176.4Z",
    fill: "#EFE6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.88 179.87L483.21 191.3",
    stroke: "#D0927C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.63 192.66C460.63 192.66 466.05 190.85 469.21 187.66",
    stroke: "#D0927C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.11 126.7L512.63 128.06L515.34 136.64L524.34 137.99L530.21 141.15L537.89 133.93L537.43 144.76C537.43 144.76 554.14 144.31 558.2 137.09C557.3 127.61 559.56 114.09 555.95 112.26C552.34 110.43 543.76 120.38 543.76 120.38L525.24 115.87L522.11 126.7Z",
    fill: "#EFE6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.439 125.35C528.439 125.35 542.439 123.54 546.039 127.15C549.639 130.76 547.849 139.34 547.849 139.34",
    stroke: "#D0927C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.13 186.06C332.76 184.19 344.03 194.93 346.92 193.59C349.81 192.25 356.45 179.86 360.2 178.25C363.95 176.64 371.76 183.71 371.76 183.71C371.76 183.71 365.11 206.95 362.65 208.17C360.19 209.39 350.36 203.4 347.86 206.04C345.36 208.68 344.55 216.94 340.53 217.69C336.51 218.44 321.92 209.17 321.92 209.17C321.92 209.17 323.51 187.93 328.13 186.06Z",
    fill: "#EFE6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.819 192.07L344.939 203.43",
    stroke: "#D0927C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.08 166.49C572.4 157.89 568.64 172.95 581.37 175.98C570.59 179.57 584.98 193.58 592.66 184.98C609.82 191.98 614.3 174.26 606.66 170.98C615.84 162.38 608.75 150.03 594.92 165.11C591.73 156.21 582.45 162.69 584.08 166.49Z",
    fill: "#EFE6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.81 180.12C578.05 184.58 584 191.77 594.07 183.94",
    stroke: "#D0927C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.109 176.24C591.109 176.24 596.279 170.87 603.639 171.66",
    stroke: "#D0927C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9079_4896"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 610.78,
    height: 217.73,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/empty_state.6cd57233.svg";
export { ForwardRef as ReactComponent };